import React from 'react';
import { useQuery } from 'react-query';

const DashbordHook = () => {
    const { isLoading, error, data: Order, refetch } = useQuery('PeendingData', () =>
        fetch('https://drab-erin-dove-suit.cyclic.app/order').then(res =>
            res.json()
        )
    )
    return { isLoading, error, Order, refetch }

};

export default DashbordHook;